module.exports = __webpack_public_path__ + "static/media/nike-good-luck-returning-that.780005e2.mp4";